/*@ngInject*/
const AdvancedFilterModel = function (advancedFilterType, filterCriterionDataType, filterType) {

    let advancedFilterModels = {};

    this.reset = function (namespace) {
        if (namespace) {
            advancedFilterModels[namespace] = {
                filterTemplate: null,
                filter: null,
                selectedFilterCriterionTemplates: null,
                unselectedFilterCriterionTemplates: null
            };
        } else {
            advancedFilterModels = {};
        }
    };

    this.getAdvancedFilterModel = function (namespace) {
        return advancedFilterModels[namespace];
    };

    this.buildFilter = function (namespace, filterTemplate, filter, selectAll) {
        let advancedFilterModel = advancedFilterModels.hasOwnProperty(namespace) ? advancedFilterModels[namespace] : {},
            filterCriteria = null;

        advancedFilterModel.selectedFilterCriterionTemplates = _.filter(filterTemplate.criterionTemplates, function (criterionTemplate) {
            filterCriteria = _.find(filter.criteria, ['filterCriterionTemplateId', criterionTemplate.id]);
            if (!_.isNil(filterCriteria)) {
                criterionTemplate.value = (filterTemplate.type === filterType.TYPE_FORMTEMPLATE_FILTER &&criterionTemplate.type === filterCriterionDataType.TYPE_BOOLEAN) ? !!filterCriteria.value : filterCriteria.value;
                return true;
            } else if (namespace === advancedFilterType.SUBMISSION_GRID && criterionTemplate.variableName === 'insuredNameOrSubmissionOrPolicyNumberSubstring') {
                // Always show the insured name quick search on the submission grid
                return true;
            }
            return selectAll;
        });

        if (!selectAll) {
            advancedFilterModel.unselectedFilterCriterionTemplates = _.sortBy(_.filter(filterTemplate.criterionTemplates, function (criterionTemplate) {
                return (_.isNil(_.find(filter.criteria, ['filterCriterionTemplateId', criterionTemplate.id])) &&
                    !(namespace === advancedFilterType.SUBMISSION_GRID && criterionTemplate.variableName === 'insuredNameOrSubmissionOrPolicyNumberSubstring'));
            }), 'name');
        }

        advancedFilterModel.filterTemplate = filterTemplate;
        advancedFilterModel.filter = filter;
        advancedFilterModels[namespace] = advancedFilterModel;
    };

    this.buildCurrentFilter = function (namespace) {
        let advancedFilterModel = advancedFilterModels[namespace],
            currentFilter = _.clone(advancedFilterModel.filter),
            selectedCriterionTemplates = advancedFilterModel.selectedFilterCriterionTemplates,
            tempCriteria = null;
        currentFilter.criteria = [];
        _.forEach(selectedCriterionTemplates, function (criterionTemplate) {
            tempCriteria = {
                filterUri: currentFilter.uri,
                filterCriterionTemplateId: criterionTemplate.id,
                value: criterionTemplate.value
            };
            currentFilter.criteria.push(tempCriteria);
        });
        return currentFilter;
    };

    this.unselectFilterCriterion = function (namespace, filterTemplateCriterionId) {
        let advancedFilterModel = advancedFilterModels[namespace],
            filterTemplateCriterion = _.remove(advancedFilterModel.selectedFilterCriterionTemplates, ['id', filterTemplateCriterionId]);
        filterTemplateCriterion[0].value = null;
        advancedFilterModel.unselectedFilterCriterionTemplates.push(filterTemplateCriterion[0]);
        advancedFilterModel.unselectedFilterCriterionTemplates = _.sortBy(advancedFilterModel.unselectedFilterCriterionTemplates, 'name');
    };

    this.selectFilterCriterion = function (namespace, filterTemplateCriterionId) {
        let advancedFilterModel = advancedFilterModels[namespace],
            filterTemplateCriterion = _.remove(advancedFilterModel.unselectedFilterCriterionTemplates, ['id', filterTemplateCriterionId]);
        advancedFilterModel.selectedFilterCriterionTemplates.push(filterTemplateCriterion[0]);
    };

};

angular.module('umCore').service('advancedFilterModel', AdvancedFilterModel);
